import { post, get} from '../../washtraxClient';

const ticketList = data => {
  return get (`yard/ticket/list`);
};

const fetchServiceDetails = () => {
  return get (`service/list-for-selectbox`);
};

const inspectFinish = data => {
  return post ('yard/action', data);
};

const ticketCompleteYard = data => {
  return post ('yard/ticket/complete', data);
};
const fetchServiceDetailsPost = () => {
  return get (`service/list-for-selectbox/post`);
};
export default {
  ticketList,
  fetchServiceDetails,
  inspectFinish,
  ticketCompleteYard,
  fetchServiceDetailsPost
};
